import { render, staticRenderFns } from "./QuickGripAd.vue?vue&type=template&id=05cf60b5&scoped=true"
import script from "./QuickGripAd.vue?vue&type=script&lang=js"
export * from "./QuickGripAd.vue?vue&type=script&lang=js"
import style0 from "./QuickGripAd.vue?vue&type=style&index=0&id=05cf60b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cf60b5",
  null
  
)

export default component.exports